export default "__VITE_ASSET__DXNtdWkX__"